var map = {
	"./amy.png": 542,
	"./annotated-example-1.png": 1715,
	"./annotated-example-2.png": 1716,
	"./annotated-example-3.png": 1717,
	"./examples-1.png": 1718,
	"./examples-2.png": 1719,
	"./examples-3.png": 1720,
	"./feedback-1.png": 1721,
	"./feedback-2.png": 1722,
	"./feedback-3.png": 1723,
	"./honor-pledge.png": 1724,
	"./icons/assignment-gray.png": 1725,
	"./icons/assignment.png": 1726,
	"./icons/dashboard-gray.png": 1727,
	"./icons/dashboard.png": 1728,
	"./icons/demo-gray.png": 1729,
	"./icons/demo.png": 1730,
	"./icons/quizzes-gray.png": 1731,
	"./icons/quizzes.png": 1732,
	"./icons/school-gray.png": 1733,
	"./icons/school.png": 1734,
	"./icons/standards-gray.png": 1735,
	"./icons/standards.png": 1736,
	"./icons/students-gray.png": 1737,
	"./icons/students.png": 1738,
	"./onboarding-book-reviews.png": 1739,
	"./onboarding-critical-thinking.png": 1740,
	"./onboarding-daily-reading.png": 1741,
	"./onboarding-fill-in-and-short-answer.png": 1742,
	"./onboarding-fill-in-only.png": 1743,
	"./onboarding-short-answer-in-only.png": 1744,
	"./onboarding-track-goals.png": 1745,
	"./onboarding-who-read.png": 1746,
	"./onboarding-writing-skills.png": 1747,
	"./owlfonso-waving.png": 543,
	"./practice-question-1.png": 1748,
	"./practice-question-2.png": 1749,
	"./practice-question-3.png": 1750,
	"./profile-action-buttons.png": 1751,
	"./quiz-1.png": 1752,
	"./quiz-2.png": 1753,
	"./quiz-3.png": 1754,
	"./quotes.png": 544,
	"./student-owl.png": 545,
	"./teacher-owl.png": 311
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 696;



//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding .\.png*
// module id = 696
// module chunks = 0